exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{background-color:gray;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none}.container{width:100%;height:100vh;top:10%;left:10%}.sigContainer{width:80%;height:80%;margin:0 auto;background-color:#fff}.sigPad{width:100%;height:150px;border:1px solid #dcdcdc}.buttons{width:100%;height:30px}.sigImage{background-size:200px 50px;width:200px;height:50px;background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/components/Screens/FieldsComponents/SignPad/sigpad.css
// module id = 374
// module chunks = 0